var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSleepy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 238.77 233.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #06334f;\n        stroke-width: 1.28px;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-1, .cls-6 {\n        stroke: #231f20;\n      }\n\n      .cls-2 {\n        stroke: #c3d6f7;\n        stroke-width: 2.28px;\n      }\n\n      .cls-2, .cls-9 {\n        fill: #e9eef7;\n      }\n\n      .cls-10 {\n        font-size: 41.76px;\n      }\n\n      .cls-10, .cls-11 {\n        font-family: MontserratRoman-ExtraBold, Montserrat;\n        font-variation-settings: 'wght' 800;\n        font-weight: 700;\n      }\n\n      .cls-3 {\n        stroke-width: 1.93px;\n      }\n\n      .cls-3, .cls-4, .cls-5, .cls-8 {\n        stroke: #4a1c0d;\n      }\n\n      .cls-3, .cls-5, .cls-8 {\n        fill: none;\n      }\n\n      .cls-4 {\n        fill: #914b2c;\n        stroke-width: 2.62px;\n      }\n\n      .cls-12 {\n        fill: #75381c;\n      }\n\n      .cls-5 {\n        stroke-width: 2.07px;\n      }\n\n      .cls-6 {\n        fill: #2e2423;\n        stroke-width: 1.94px;\n      }\n\n      .cls-7 {\n        fill: #dae8f0;\n        stroke: #406f8c;\n        stroke-width: 2px;\n      }\n\n      .cls-13 {\n        fill: #9d4623;\n      }\n\n      .cls-8 {\n        stroke-width: 1.93px;\n      }\n\n      .cls-11 {\n        font-size: 24.62px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.65,233.2c-2.77-8.49-2.95-17.61-2.9-26.56.06-10.05.4-20.1,1-30.14.18-2.99.42-6.1,1.88-8.69,2.41-4.29,7.48-6.11,12.17-7.37,10.06-2.7,20.39-4.34,30.77-4.96,11.73-.7,23.49-.11,35.24.17,23.68.57,47.38-.13,70.99-2.1,7.82-.65,16.6-1.15,22.53,4.09,4.45,3.93,6.1,10.15,7.26,16.02,3.71,18.85,4.62,38.19,3.89,57.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M159.76,2.99c6.91.69,13.85,1.58,20.46,3.69,4.03,1.28,8.14,3.19,10.5,6.71,4.82-5.63,12.34-8.84,19.74-8.42,1.17.07,2.55.36,3.03,1.43.33.74.11,1.61-.2,2.36-2.01,4.86-7.04,7.64-11.72,10.05,4.01,6.15,4.76,13.79,5.41,21.1,1.47,16.69,2.88,33.93-2.4,49.83-1.98,5.94-4.8,12.72-1.54,18.06,1.06,1.73,2.67,3.09,3.62,4.88.95,1.79.95,4.4-.77,5.46-1.04.64-2.37.52-3.56.25-5.94-1.32-11.1-5.76-13.27-11.44-16.02,7.43-33.87,9.86-51.49,11.13-26.53,1.92-53.23,1.43-79.66-1.47-11.5-1.26-23.06-3-33.84-7.19-1.95,5.11-7.12,8.11-11.93,10.7-.9.49-1.92.99-2.91.73-1.28-.34-1.91-1.79-2.09-3.09-.99-7.08,5.55-12.71,11.39-16.84C.93,78.37-2.06,45.43,11.18,20.09c-4.11-2.77-7.41-6.74-9.38-11.3-.69-1.59-1.2-3.49-.36-5C5.62-3.7,15.2,13.07,20.08,13.39c3.94.26,8.84-1.91,12.63-2.76,5.82-1.3,11.67-2.47,17.54-3.51C73.59,3,97.28.95,120.97,1c12.95.03,25.91.68,38.79,1.98Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 95.94,
    y: 101.08,
    width: 21.62,
    height: 40.57,
    rx: 10.81,
    ry: 10.81
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 104.54,
    cy: 69.21,
    rx: 49.66,
    ry: 51.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 53.6,
    cy: 80.84,
    r: 11.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 156.79,
    cy: 80,
    r: 11.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M76.92,58.96s2.66-4.42,8.35-6.46c5.69-2.04,12.85-.06,12.85-.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M132.86,58.96s-2.66-4.42-8.35-6.46c-5.69-2.04-12.85-.06-12.85-.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M152.82,83.88s3.41-5.42,10.08-4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M58.94,83.86s-3.41-5.42-10.08-4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M127.44,71.17c-2.28,2.11-5.22,3.39-8.42,3.39-2.72,0-5.25-.92-7.35-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M95.4,71.17c-2.28,2.11-5.22,3.39-8.42,3.39-2.72,0-5.25-.92-7.35-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M101.99,80.42s-2.84,8.59,2.27,9.51c5.51,1,4.97-7.73,4.97-7.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M212.89,165.48c-5.32,6.34-19.84,1.96-27.33.87-6.56-1.25-13.2-2.52-19.9-2.24-8.03.3-15.61,3.62-23.54,4.14-10.3.68-20.63-1.44-30.91-.1-15.77,2.18-31.56,8.06-47.34,5.31-8.35-1.42-16.75-3.26-25.26-2.23-6.8.3-15.34,3.03-20.5-.75-5.11-3.96-5.3-13.55-4.75-20.53,1.28-13.49,10.77-16.76,22.55-17.45,54.09-3.77,108.55-2.74,162.68-6.92,15.98.26,16.96,15.56,16.78,30.07-.07,3.31-.43,7.09-2.39,9.69l-.1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.11,170.48c-5.11-3.96-5.3-13.55-4.75-20.53,1.28-13.49,10.77-16.76,22.55-17.45,54.09-3.77,108.55-2.74,162.68-6.92,15.98.26,16.96,15.56,16.78,30.07-.07,3.31-.43,7.09-2.39,9.69l-.1.13"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-11",
    transform: "translate(187.54 71.15) rotate(-4.43)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "z")), /*#__PURE__*/React.createElement("text", {
    className: "cls-10",
    transform: "translate(214.79 52.56) rotate(-4.43)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "z")), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M152.54,57.7c-17.12-.02-31.31-12.24-33.94-28.23-6.18,8.93-16.65,14.79-28.52,14.79-7.14,0-13.74-2.11-19.22-5.71-.62,10.34-7.02,19.17-16.08,23.45,1.89-10.05,6.2-19.13,12.18-26.42,1.11-1.33,2.26-2.61,3.47-3.83,8.95-8.97,20.74-14.43,33.71-14.43,4.99,0,9.81.8,14.35,2.32,1.46.48,2.87,1.01,4.25,1.64,14.31,6.34,25.4,19.76,29.81,36.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M103.92,102.51c1.32-2.02,3.64-3.23,6.02-3.61s4.82-.02,7.15.57"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleepy);
export default __webpack_public_path__ + "static/media/sleepy.eabe40144c753e9800e3e820f7713b8b.svg";
export { ForwardRef as ReactComponent };